import {blobToBase64} from '@legit.health/ui';
import FormValues from '../interfaces/FormValues';

export default async function mapFormValuesToApiFormat(values: FormValues) {
  const imagesSubmitted = values.images.filter((image) => image.file);
  const images = await Promise.all(
    imagesSubmitted.map(async function (image) {
      if (!image.file) {
        throw new Error('This cannot happen');
      }
      const base64Image = await blobToBase64(image.file);
      return {
        x: image.crop.x,
        y: image.crop.y,
        width: image.crop.width,
        height: image.crop.height,
        image: base64Image
      };
    })
  );
  const base64MacroscopicMedia = values.macroscopicMedia
    ? await blobToBase64(values.macroscopicMedia)
    : null;
  return {
    bodySite: values.bodySiteCode,
    images,
    extraData: values.extraData,
    companyCallbackUrl: values.companyCallbackUrl,
    visitIdentifier: values.visitIdentifier,
    anamnesisQuestions: Object.keys(values.anamnesisQuestions).map((anamnesisQuestionId) => ({
      anamnesisQuestion: anamnesisQuestionId,
      answer: values.anamnesisQuestions[anamnesisQuestionId]
    })),
    macroscopicMedia: base64MacroscopicMedia
  };
}
